import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  destinations: [],
  pagination: {},
  loading: false,
  current: {},
};

const destinationsReducer = createReducer(initialState)({
  // GET DESTINATION LIST
  [types.FETCH_DESTINATIONS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_DESTINATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      destinations: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_DESTINATIONS_FAILED]: (state) => {
    return {
      ...state,
      destinations: [],
      loading: false,
    };
  },

  // CREATE DESTINATION
  [types.CREATE_DESTINATION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      current: {
        ...state.current,
        loading: true,
      },
    };
  },
  [types.CREATE_DESTINATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      current: {
        ...state.current,
        loading: false,
      },
    };
  },
  [types.CREATE_DESTINATION_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      current: {
        ...state.current,
        loading: false,
      },
    };
  },

  // UPDATE DESTINATION
  [types.SET_CURRENT_DESTINATION]: (state, { payload }) => {
    return {
      ...state,
      current: {
        ...payload,
      },
    };
  },
  [types.UPDATE_DESTINATION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      current: {},
    };
  },
  [types.UPDATE_DESTINATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      current: {},
    };
  },
  [types.UPDATE_DESTINATION_FAILED]: (state, { payload: errors }) => {
    return {
      ...state,
      loading: false,
      current: {
        ...state.current,
        loading: false,
        errors,
      },
    };
  },

  // DELETE DESTINATION
  [types.DELETE_DESTINATION_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      current: {},
    };
  },
  [types.DELETE_DESTINATION_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      current: {},
    };
  },
  [types.DELETE_DESTINATION_BY_ID_FAILED]: (state, { payload: errors }) => {
    return {
      ...state,
      loading: false,
      current: {
        ...state.current,
        loading: false,
        errors,
      },
    };
  },
});

export default destinationsReducer;
